<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();

interface Props {
  redirectUrl: string;
}

defineProps<Props>();

const previewBackgroundStyle = {
  backgroundColor: "#f2f4f7",
};
</script>

<template>
  <div class="preview-container preview-container--url">
    <div class="mb-2 text-sm font-medium text-gray-600">
      {{ t("common.preview") }}
    </div>
    <div
      class="bg-container relative mx-auto flex min-h-[232px] w-full items-center justify-center overflow-hidden rounded-[12px] px-8 py-4"
      :style="previewBackgroundStyle"
    >
      <div
        class="z-10 flex w-[384px] flex-col items-center gap-2 rounded-lg bg-white p-8 text-center"
      >
        <div class="text-[24px] leading-[32px]">🚶🏻</div>
        <div class="text-xs font-medium leading-[17px] text-gray-900">
          {{ t("common.redirectMessage") }}
        </div>
        <div class="text-[10px] font-normal leading-[15px] text-[#155eef]">
          {{ redirectUrl || "example.com" }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.preview-container {
  height: auto;
  padding-bottom: 8px;
}

.preview-container--url {
  height: 240px;
  margin-bottom: 16px;
}

.bg-container {
  position: relative;
  height: 100%;
}
</style>
